var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZmdiSmartphoneErase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4823_74314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7691 9.96059L7.67347 15.0563L12.7691 20.2119L11.5102 21.4708L6.41454 16.3751L1.25893 21.4708L0 20.2119L5.09566 15.0563L0 9.96059L1.25893 8.70166L6.41454 13.7973L11.5102 8.70166L12.7691 9.96059ZM20.4426 0.728447C21.162 0.728447 21.7715 0.978234 22.271 1.47781C22.7706 1.97738 23.0204 2.58687 23.0204 3.30625V26.3267C23.0204 27.046 22.7706 27.6555 22.271 28.1551C21.7715 28.6547 21.162 28.9045 20.4426 28.9045H7.67347C6.95408 28.9045 6.3446 28.6547 5.84503 28.1551C5.34545 27.6555 5.09566 27.046 5.09566 26.3267V22.4899H7.67347V25.0677H20.4426V4.56518H7.67347V7.14299H5.09566V3.30625C5.09566 2.58687 5.34545 1.97738 5.84503 1.47781C6.3446 0.978234 6.95408 0.728447 7.67347 0.728447H20.4426Z",
    fill: "#6C757D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4823_74314"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.0204,
    height: 28.7755,
    fill: "white",
    transform: "translate(0 0.428711)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZmdiSmartphoneErase);
export default __webpack_public_path__ + "static/media/zmdi_smartphone-erase.abfe7362bfbc3b69bc2b358357660dd8.svg";
export { ForwardRef as ReactComponent };